const enqueueScript = (script: HTMLScriptElement) => {
    return new Promise((resolve) => {
        script.addEventListener("load", resolve);
        script.addEventListener("error", resolve);
        document.head.appendChild(script);
        if (!script.src) resolve(true);
    });
}

export const enqueueScripts = async (scripts: HTMLScriptElement[]) => {
    for (const script of scripts) {
        if (script.id) {
            const existing = document.getElementById(script.id);
            if (existing && existing.localName === "script") continue;
        } else if (script.src) {
            const existing = Array.from(document.scripts).some(item => item.src === script.src);
            if (existing) continue;
        }

        await enqueueScript(script);
    }
};
